import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/views/layout/Layout'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: Layout,
      children: [
        { path: '', name: 'Home', component: () => import('@/views/Home'), meta: { keepAlive: true } },
        { path: '/papers', name: 'PaperList', component: () => import('@/views/paper/PaperList'), meta: { keepAlive: true } },
        { path: '/papers/:id', name: 'Paper', component: () => import('@/views/paper/Paper'), meta: { keepAlive: false } },
        { path: '/reports', name: 'ReportList', component: () => import('@/views/report/ReportList'), meta: { keepAlive: true } },
        { path: '/reports/last', name: 'LastReport', component: () => import('@/views/report/Report'), meta: { keepAlive: false } },
        { path: '/reports/:id', name: 'Report', component: () => import('@/views/report/Report'), meta: { keepAlive: false } },
        { path: '/reports/:id/print', name: 'ReportPrint', component: () => import('@/views/report/ReportPrint'), meta: { keepAlive: false } },
        { path: '/profile', name: 'Profile', component: () => import('@/views/Profile'), meta: { keepAlive: false } }
      ]
    },
    { path: '/login', name: 'Login', component: () => import('@/views/Login'), meta: { keepAlive: false } }
  ],
  scrollBehavior (to, from, saveTop) {
    if (saveTop) {
      return saveTop
    } else {
      return {x: 0, y: 0}
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js